import { jsx as _jsx } from "react/jsx-runtime";
import { HeaderContentStyled } from '../header.styled';
export const HeaderContent = (props) => {
    // always returned something, cause we need to put container to flex direction
    const ariaHidden = props.children.length > 0 ? false : true;
    return (_jsx(HeaderContentStyled, { "aria-hidden": ariaHidden, styles: props.styles, children: props.children }));
};
//# sourceMappingURL=headerContent.js.map